import { initialState } from "./state";

export const activities = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVITIES_LIST": {
      return Object.assign({}, state, {
        activitiesList: action.data.activitiesList,
        has_next: action.data.has_next,
        next_page: action.data.next_page,
        offset: action.data.offset,
        prev_page: action.data.prev_page,
      });
    }
    case "SET_LOCKED_ACTIVITIES": {
      return {
        ...state,
        lockedActivitiesList: action.data,
      };
    }
    case "SET_UNLOCKED_ACTIVITIES": {
      return {
        ...state,
        unlockedActivitiesList: action.data,
      };
    }
    case "SET_READING_LIST": {
      return {
        ...state,
        readingList: action.data,
      };
    }
    case "SET_ACTIVITY_DETAIL": {
      return {
        ...state,
        activeActivity: action.data,
      };
    }
    case "SET_ACTIVITY_QUESTIONS_LIST": {
      return {
        ...state,
        activeActivityQuestionsList: action.data.result,
      };
    }
    case "SET_ACTIVITIES_LOADING": {
      return {
        ...state,
        loading: action.data,
      };
    }
    case "SET_LOADING_ACTIVITIES": {
      return {
        ...state,
        loadingActivities: action.data,
      };
    }
    default:
      return state;
  }
};
